<!-- Fin Form agregar modulos permisos -->
<form [formGroup]="formAcs" (ngSubmit)="saveModul()">
    <div class="w-75 p-3 mb-2">
        <div class="row mb-5">
            <h5>Lista de acceso : {{namePerson['name']}} {{namePerson['lastname']}}</h5>
        </div>
        <div class="form-group row">

            <div class="textOnInput col-12  col-md-4">
                <label class="form-label">Modulos</label>
                <select class="form-select form-input" formControlName="accessId"
                    [ngClass]="{'is-invalid': submitted && f['accessId'].errors }">
                    <option *ngIf="bandCB==0" selected disabled value="null">Seleccione un módulo...</option>
                    <option *ngIf="bandCB==1" selected disabled value="null">Tienes acceso a todos
                        los módulos</option>
                    <option *ngFor="let modul of modulstemp" value="{{modul.id}}">
                        {{modul.modulo}}
                    </option>
                </select>
                <div *ngIf="submitted && f['accessId'].errors" class="invalid-feedback">
                    <div *ngIf="f['accessId'].errors.required">Por favor, selecciona el módulo</div>
                </div>
            </div>

            <div class="textOnInput col-12  col-md-5">
                <label class="form-label">Permisos</label>
                <div class="label-container">
                    <div class="row">

                        <div class="form-group col-12 col-md-4">
                            <div class="align-switch">
                                <div class="form-check form-switch">
                                    <input class="form-check-input" type="checkbox" id="switch1"
                                        formControlName="create">
                                    <label class="custom-control-label" for="switch1"> Crear </label>
                                </div>
                            </div>
                        </div>

                        <div class="form-group col-12 col-md-4">
                            <div class="align-switch">
                                <div class="form-check form-switch">
                                    <input class="form-check-input" type="checkbox" id="switch2" formControlName="edit">
                                    <label class="custom-control-label" for="switch2"> Editar </label>
                                </div>
                            </div>
                        </div>

                        <div class="form-group col-12 col-md-4">
                            <div class="align-switch">
                                <div class="form-check form-switch">
                                    <input class="form-check-input" type="checkbox" id="switch3" formControlName="edit">
                                    <label class="custom-control-label" for="switch3"> Eliminar </label>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="col-md-2">
                <div class="row">
                    <button type="submit" class=" btn-add" *ngIf="bandCB==0"><i class="fa fa-plus px-2"></i> Agregar
                        acceso</button>
                    <button type="submit" class="btn btn-outline-secondary btn-sm
                    " disabled *ngIf="bandCB==1"><i class="fa fa-plus px-2"></i> Agregar acceso</button>
                </div>

            </div>
        </div>
    </div>
</form>
<!-- Inicio Form agregar modulos permisos -->

<!-- Inicio Tabla -->
<div class="row">
    <div class="table-responsive">
        <table class="table">
            <thead class="thead-detail text-center table-success">
                <tr>
                    <th scope="col">N°</th>
                    <th scope="col">Módulo</th>
                    <!--    <th scope="col">Permisos</th> -->
                    <th scope="col">Editar permiso</th>
                    <th scope="col">Quitar acceso</th>
                </tr>
            </thead>
            <tbody>

                <tr class="tbody-detail" *ngFor="let item of accesses; let i = index">
                    <td>{{i+1}}</td>
                    <td>{{item.menu}}</td>
                    <!--                 <td class="text-light">
                    <span *ngIf="item.access_user.create" class="badge bg-success">crear contenido</span>
                    <span *ngIf="!item.access_user.create" class="badge bg-danger">crear contenido</span>&nbsp;

                    <span *ngIf="item.access_user.edit" class="badge bg-success">editar contenido</span>
                    <span *ngIf="!item.access_user.edit" class="badge bg-danger">editar contenido</span>&nbsp;

                    <span *ngIf="item.access_user.del" class="badge bg-success">eliminar contenido</span>
                    <span *ngIf="!item.access_user.del" class="badge bg-danger">eliminar contenido</span>
                </td> -->
                    <td><a class="a-icon text-center" (click)="changeModel(item.access_user, item.modulo)"><i
                                class="fa fa-pencil i-icon"></i></a></td>

                    <td><a class="a-icon text-center"
                            (click)="deleteOneModuleAccess(item.access_user.userId,item.access_user.accessId, item.modulo)"><i
                                class="fa fa-trash i-icon"></i></a></td>
                </tr>

            </tbody>
        </table>
    </div>
</div>
<!-- Fin Tabla -->

<!-- Inicio Modal -->
<div class="modal fade" id="testModal" tabindex="-1" role="dialog" role="dialog" aria-labelledby="myModalLabel"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">

            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalCenterTitle">Administrar permiso de Modulo</h5>
                <a type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></a>
            </div>

            <div class="modal-body">
                <ng-container *ngIf="flagAdmUser===false && flagContentIncorporated==false">

                    <div class="textOnInput col-md-12">
                        <label class="form-label">Permisos Ficha</label>
                        <div class="label-container">
                            <div class="row">

                                <div class="form-group col-12 col-md-4">
                                    <div class="align-switch">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" id="switch4"
                                                [(ngModel)]="accessCreate">
                                            <label class="custom-control-label" for="switch4"> Crear </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group col-12 col-md-4">
                                    <div class="align-switch">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" id="switch5"
                                                [(ngModel)]="accessEdit">
                                            <label class="custom-control-label" for="switch5"> Editar </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group col-12 col-md-4">
                                    <div class="align-switch">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" id="switch6"
                                                [(ngModel)]="accessDelete">
                                            <label class="custom-control-label" for="switch6"> Eliminar </label>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="textOnInput col-md-12">
                        <label class="form-label">Permisos Sección</label>
                        <div class="label-container">
                            <div class="row">

                                <div class="form-group col-12 col-md-4">
                                    <div class="align-switch">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" id="switch7"
                                                [(ngModel)]="createSection">
                                            <label class="custom-control-label" for="switch7"> Crear </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group col-12 col-md-4">
                                    <div class="align-switch">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" id="switch8"
                                                [(ngModel)]="editSection">
                                            <label class="custom-control-label" for="switch8"> Editar </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group col-12 col-md-4">
                                    <div class="align-switch">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" id="switch9"
                                                [(ngModel)]="deleteSection">
                                            <label class="custom-control-label" for="switch9"> Eliminar </label>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <ng-container *ngIf="flagModal===false">

                        <div class="textOnInput col-md-12">
                            <label class="form-label">Permisos Subsección</label>
                            <div class="label-container">
                                <div class="row">

                                    <div class="form-group col-12 col-md-4">
                                        <div class="align-switch">
                                            <div class="form-check form-switch">
                                                <input class="form-check-input" type="checkbox" id="switch10"
                                                    [(ngModel)]="createSubsection">
                                                <label class="custom-control-label" for="switch10"> Crear </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group col-12 col-md-4">
                                        <div class="align-switch">
                                            <div class="form-check form-switch">
                                                <input class="form-check-input" type="checkbox" id="switch11"
                                                    [(ngModel)]="editSubsection">
                                                <label class="custom-control-label" for="switch11"> Editar </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group col-12 col-md-4">
                                        <div class="align-switch">
                                            <div class="form-check form-switch">
                                                <input class="form-check-input" type="checkbox" id="switch12"
                                                    [(ngModel)]="deleteSubsection">
                                                <label class="custom-control-label" for="switch12"> Eliminar </label>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="textOnInput col-md-12">
                            <label class="form-label">Permisos Gráfico</label>
                            <div class="label-container">
                                <div class="row">

                                    <div class="form-group col-12 col-md-4">
                                        <div class="align-switch">
                                            <div class="form-check form-switch">
                                                <input class="form-check-input" type="checkbox" id="switch13"
                                                    [(ngModel)]="createGraphic">
                                                <label class="custom-control-label" for="switch13"> Crear </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group col-12 col-md-4">
                                        <div class="align-switch">
                                            <div class="form-check form-switch">
                                                <input class="form-check-input" type="checkbox" id="switch14"
                                                    [(ngModel)]="editGraphic">
                                                <label class="custom-control-label" for="switch14"> Editar </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group col-12 col-md-4">
                                        <div class="align-switch">
                                            <div class="form-check form-switch">
                                                <input class="form-check-input" type="checkbox" id="switch15"
                                                    [(ngModel)]="deleteGraphic">
                                                <label class="custom-control-label" for="switch15"> Eliminar </label>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="textOnInput col-md-12">
                            <label class="form-label">Permisos Bibliografía</label>
                            <div class="label-container">
                                <div class="row">

                                    <div class="form-group col-12 col-md-4">
                                        <div class="align-switch">
                                            <div class="form-check form-switch">
                                                <input class="form-check-input" type="checkbox" id="switch16"
                                                    [(ngModel)]="createBiblio">
                                                <label class="custom-control-label" for="switch16"> Crear </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group col-12 col-md-4">
                                        <div class="align-switch">
                                            <div class="form-check form-switch">
                                                <input class="form-check-input" type="checkbox" id="switch17"
                                                    [(ngModel)]="editBiblio">
                                                <label class="custom-control-label" for="switch17"> Editar </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group col-12 col-md-4">
                                        <div class="align-switch">
                                            <div class="form-check form-switch">
                                                <input class="form-check-input" type="checkbox" id="switch18"
                                                    [(ngModel)]="deleteBiblio">
                                                <label class="custom-control-label" for="switch18"> Eliminar </label>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="textOnInput col-md-12">
                            <label class="form-label">Permisos Fuentes primarias</label>
                            <div class="label-container">
                                <div class="row">

                                    <div class="form-group col-12 col-md-4">
                                        <div class="align-switch">
                                            <div class="form-check form-switch">
                                                <input class="form-check-input" type="checkbox" id="switch19"
                                                    [(ngModel)]="createSource">
                                                <label class="custom-control-label" for="switch19"> Crear </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group col-12 col-md-4">
                                        <div class="align-switch">
                                            <div class="form-check form-switch">
                                                <input class="form-check-input" type="checkbox" id="switch20"
                                                    [(ngModel)]="editSource">
                                                <label class="custom-control-label" for="switch20"> Editar </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group col-12 col-md-4">
                                        <div class="align-switch">
                                            <div class="form-check form-switch">
                                                <input class="form-check-input" type="checkbox" id="switch21"
                                                    [(ngModel)]="deleteSource">
                                                <label class="custom-control-label" for="switch21"> Eliminar </label>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <ng-container
                            *ngIf="flagDocList===true || flagRT===true || flagRS===true || flagGD===true || flagGI===true">
                            <p>Permisos nuevas secciones</p>
                        </ng-container>

                        <ng-container *ngIf="flagDocList===true">
                            <div class="textOnInput col-md-12">
                                <label class="form-label">Cargar listado y documento metodológico</label>
                                <div class="label-container">
                                    <div class="row">
                                        <div class="form-group col-12 col-md-12">
                                            <div class="align-switch">
                                                <div class="form-check form-switch">
                                                    <input class="form-check-input" type="checkbox" id="switch22"
                                                        [(ngModel)]="createDoc">
                                                    <label class="custom-control-label" for="switch22"> Permitir</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="flagRT===true">
                            <div class="textOnInput col-md-12">
                                <label class="form-label">Cargar reporte territorial</label>
                                <div class="label-container">
                                    <div class="row">
                                        <div class="form-group col-12 col-md-12">
                                            <div class="align-switch">
                                                <div class="form-check form-switch">
                                                    <input class="form-check-input" type="checkbox" id="switch23"
                                                        [(ngModel)]="createReportT">
                                                    <label class="custom-control-label" for="switch23"> Permitir</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="flagRS===true">
                            <div class="textOnInput col-md-12">
                                <label class="form-label">Cargar reporte sectorial</label>
                                <div class="label-container">
                                    <div class="row">
                                        <div class="form-group col-12 col-md-12">
                                            <div class="align-switch">
                                                <div class="form-check form-switch">
                                                    <input class="form-check-input" type="checkbox" id="switch24"
                                                        [(ngModel)]="createReportS">
                                                    <label class="custom-control-label" for="switch24"> Permitir</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="flagGD===true">
                            <div class="textOnInput col-md-12">
                                <label class="form-label">Cargar gráfico de dispersión</label>
                                <div class="label-container">
                                    <div class="row">
                                        <div class="form-group col-12 col-md-12">
                                            <div class="align-switch">
                                                <div class="form-check form-switch">
                                                    <input class="form-check-input" type="checkbox" id="switch25"
                                                        [(ngModel)]="createGD">
                                                    <label class="custom-control-label" for="switch25"> Permitir</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="flagGI===true">
                            <div class="textOnInput col-md-12">
                                <label class="form-label">Cargar gráfico de interrelación</label>
                                <div class="label-container">
                                    <div class="row">
                                        <div class="form-group col-12 col-md-12">
                                            <div class="align-switch">
                                                <div class="form-check form-switch">
                                                    <input class="form-check-input" type="checkbox" id="switch26"
                                                        [(ngModel)]="createGI">
                                                    <label class="custom-control-label" for="switch26"> Permitir</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                    </ng-container>
                </ng-container>

                <ng-container *ngIf="flagAdmUser===true && flagContentIncorporated==false">
                    <p>La admnistracion de este modulo solo es acceso y no permisos. Si usted desea restringir el acceso
                        haga click en el boton quitar acceso.</p>
                </ng-container>

                <ng-container *ngIf="flagAdmUser===false && flagContentIncorporated==true">
                    <div class="textOnInput col-md-12">
                        <label class="form-label">Permisos Contenido</label>
                        <div class="label-container">
                            <div class="row">

                                <div class="form-group col-12 col-md-4">
                                    <div class="align-switch">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" id="switch22"
                                                [(ngModel)]="accessCreate">
                                            <label class="custom-control-label" for="switch22"> Crear </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group col-12 col-md-4">
                                    <div class="align-switch">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" id="switch23"
                                                [(ngModel)]="accessEdit">
                                            <label class="custom-control-label" for="switch23"> Editar </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group col-12 col-md-4">
                                    <div class="align-switch">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" id="switch24"
                                                [(ngModel)]="accessDelete">
                                            <label class="custom-control-label" for="switch24"> Eliminar </label>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="textOnInput col-md-12">
                        <label class="form-label">Permisos nuevas secciones</label>
                        <div class="label-container">
                            <div class="row">
                                <div class="form-group col-12 col-md-12">
                                    <div class="align-switch">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" id="switch27"
                                                [(ngModel)]="createText">
                                            <label class="custom-control-label" for="switch27"> Cargar texto
                                                introductorio </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>

            </div>

            <div class="modal-footer">
                <ng-container *ngIf="flagAdmUser===false">
                    <button type="button" class="btn btn-outline-primary btn-sm" (click)="save()">Guardar</button>
                    <button type="button" class="btn btn-outline-secondary btn-sm"
                        data-bs-dismiss="modal">Cancelar</button>
                </ng-container>
                <ng-container *ngIf="flagAdmUser===true">
                    <button type="button" class="btn btn-outline-secondary btn-sm"
                        data-bs-dismiss="modal">Cerrar</button>
                </ng-container>

            </div>

        </div>
    </div>
</div>
<!-- Fin Modal -->